<template>
  <div class="crpg-a-common-zoom-image">
    <img
      :src="image"
      :style="{ width: width + 'px', height: height + 'px' }"
      class="crpg-a-common-zoom-image__zoom"
    />
    <div class="crpg-a-common-zoom-image__icon">
      <div class="crpg-a-common-zoom-image__icon__alt">{{ alt }}</div>
      <div
        class="crpg-a-common-zoom-image__icon__close crpg-icon-extra"
        @click.self="close"
      >
        CLOSE
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/atoms/common/zoomImage.scss";
</style>

<script>
export default {
  name: "AtomsCommonZoomImage",
  props: {
    image: {
      String: "",
    },
    width: {
      String: "",
    },
    height: {
      String: "",
    },
    alt: {
      String: "",
    },
  },
  methods: {
    close() {
      this.$store.dispatch("zoom/hide", [null, ""]);
    },
  },
};
</script>
